import script from "./BlogsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogsDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__